import { History } from "@/components/conversation-details/feedback/teen-wellbeing/history.tsx";
import { MentorshipFeedback } from "@/lib/api/mentorships.ts";
import { TeenWellbeingStats } from "./teen-wellbeing-stats";

type TeenWellbeingProps = MentorshipFeedback["teenWellBeing"];

export function TeenWellbeing({ current, history }: TeenWellbeingProps) {
  return (
    <div className="flex flex-col gap-4">
      <TeenWellbeingStats current={current} />

      <History data={history} />
    </div>
  );
}
